import { render } from "./Main.vue?vue&type=template&id=7d808429"
const script = {}
script.render = render

export default script